import { Outlet } from 'react-router-dom';
import { useMyAccess } from '@/lib/access/access-context';
import { canCapture } from '@/lib/access/access-model';
import { NoCaptureAccess } from './NoCaptureAccess';

/**
 * Gates every capture entry route (OPERATOR_ACCESS.md section 5): the
 * viewfinder, the workflow picker, the quality-gate retake and rapid
 * session all build toward the shutter, so all four sit behind this rather
 * than each checking `captureInField` on its own. `/capture/:captureId/result`
 * is not one of them: opening a capture already taken needs no capture
 * right at all, and the reviewer footer on that screen is gated by
 * `reviewCaptures` instead (`components/review/review-model.ts`).
 */
export function RequireCapture() {
  const { access } = useMyAccess();

  if (!canCapture(access)) {
    return <NoCaptureAccess />;
  }

  return <Outlet />;
}
